import React from 'react'
import { TableViewType } from 'components/Shared/MuiTable'
import { GridPinnedColumns } from '@mui/x-data-grid-pro'
import PartiTable from 'components/Shared/MuiTable/PartiTable'
import { GridColDef } from '@mui/x-data-grid-pro'
import styled from 'particles/themes/styled'
import style from './style'
import { useWindowSize } from 'hooks'

interface TeamTableProps {
    className?: string
    isLoading: boolean
    rows: any[]
    columns: GridColDef[]
    pinnedColumns?: GridPinnedColumns
    hideFooter: boolean
}

const TeamTable: React.FC<TeamTableProps> = ({ className, isLoading, rows, columns, hideFooter }) => {
    const windowSize = useWindowSize()

    return (
        <div className={className}>
            <PartiTable
                rowHeight={54}
                columns={columns}
                rows={rows}
                hideToolbar={true}
                enableExport={false}
                showFilter={false}
                showSearchBar={false}
                viewType={TableViewType.TEAM_LIST}
                disableColumnMenu={true}
                hideFooterRowCount={true}
                isLoading={isLoading}
                hideTableBorder
                noPadding
                tableHeight={windowSize && windowSize > 768 ? '80vh' : '60vh'}
                hideFooter={hideFooter}
            />
        </div>
    )
}

export default styled(TeamTable)`
    ${style}
`
